import React from 'react'
import { Box,Stack,Typography } from '@mui/material'
import HorizontalScrollbar from './HorizontalScrollBar'
import Loader from './Loader'

const SimilarExercises = ({targetMuscleExercises,equipmentExercises}) => {
  return (
    <Box 
        sx={{mt:{lg:'100px',xs:'0'}}}
    >
        <Typography variant='h3' mb={6} backgroundColor='#fcc757'
        textAlign={'center'}
        borderRadius={'20px'}
        p={'20px'}>
            Exercises that target the same <span style={{color: '#ff2625', textTransform: 'capitalize'}}>Muscle Group</span>.
        </Typography>
        <Stack direction={"row"} sx={{p:'2',position:'relative'}} mb={6}>
            {targetMuscleExercises.length ? <HorizontalScrollbar data={targetMuscleExercises}/> :<Loader/>}
        </Stack>

        <Typography variant='h3' mb={6} backgroundColor='#fcc757'
        textAlign={'center'}
        borderRadius={'20px'}
        p={'20px'}>
            Exercises that use the same <span style={{color: '#ff2625', textTransform: 'capitalize'}}>Equipments</span>.
        </Typography>
        <Stack direction={"row"} sx={{p:'2',position:'relative'}} mb={6}>
            {equipmentExercises.length ? <HorizontalScrollbar data={equipmentExercises}/> :<Loader/>}
        </Stack>
    </Box>
  )
}

export default SimilarExercises